export const PRIMARY = '#e74c3c';